// admin-ticket-analytics-dashboard S2 — Ticket Analytics route
//
// Access: org_admin + supervisor (R4). super_admin / operator → denied
// message. Server is the real authority (each endpoint independently
// enforces role + location scope via assert-location-scope.ts); this is a
// UX gate only, mirroring the audit-log route convention.
//
// NOTE: .index.tsx suffix REQUIRED (same convention as audit-log route).

import { useTranslation } from '@jq4race/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';

import { getCurrentSession } from '../app/auth-state';
import { AnalyticsPage } from '../modules/analytics/ui/pages/AnalyticsPage';
import { PageHeader } from '../modules/app-shell/ui/PageHeader';

const ALLOWED_ROLES = ['org_admin', 'supervisor'];

function AnalyticsRouteComponent() {
  const session = getCurrentSession();
  const role = session?.user.role ?? '';

  if (!ALLOWED_ROLES.includes(role)) {
    return <DeniedPage />;
  }

  return <AnalyticsPage actorRole={session?.user.role} />;
}

function DeniedPage() {
  const { t } = useTranslation('analytics');
  return (
    <div className="space-y-8">
      <PageHeader eyebrow={t('page.eyebrow')} title={t('page.title')} />
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <ShieldOff className="h-10 w-10 text-jq-stone" strokeWidth={1.25} />
        <p className="text-[14px] font-medium text-jq-charcoal">
          You do not have permission to view ticket analytics.
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/analytics/')({
  component: AnalyticsRouteComponent,
  staticData: {
    breadcrumb: ['Analytics', 'Ticket Analytics'],
  },
});
